import { Component, EventEmitter, Input, Output } from '@angular/core';
import { startWith } from 'rxjs';
import { CommonModule } from '@angular/common';

import { PaginationComponent } from '../pagination/pagination.component';
import type {
  PaginationMaxSize,
  PaginationPageSize,
} from '../pagination/pagination.model';
import { PaginationService } from '../pagination/pagination.service';

@Component({
  selector: 'wl-pagination-by-url',
  templateUrl: './pagination-by-url.component.html',
  standalone: true,
  imports: [PaginationComponent, CommonModule],
})
export class PaginationByUrlComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() collectionSize = 1;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rotate = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() maxSize: PaginationMaxSize = 1;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() pageSize: PaginationPageSize = 1;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isXpEditor = false;

  @Output() pageChange = new EventEmitter<number>(true);

  constructor(private readonly paginationService: PaginationService) {}

  get currentPage$() {
    return this.paginationService.currentPage$.pipe(startWith(1));
  }

  public async changePage(pageNumber: number) {
    this.pageChange.emit(pageNumber);

    // We ignore page events in XP editor view in order to be able to show content.
    if (!this.isXpEditor) {
      await this.paginationService.initPagination(
        pageNumber,
        this.collectionSize
      );
    }
  }
}
